module.exports = __webpack_public_path__ + "static/media/globalUser.01b57ea3.svg";